import React, { useEffect, useState } from "react";
import { get } from "../../utils/fetchAPI";  // Import the delete (del) function
import DataTable from "react-data-table-component";
import { FaSearch } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { TiUserAddOutline } from "react-icons/ti";
import {useNavigate, useSearchParams} from "react-router-dom";
import PageTitle from "../../components/page-title/pageTitle";
import { BiSolidUser } from "react-icons/bi";
import CustomPagination from "../../components/pagination/CustomPagination";
import Loader from "../../components/loader/loder";

const DoctorList = () => {
    const[showRoleModal, setShowRoleModal] =useState(false)
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(() => {
        return parseInt(searchParams.get("page")) || 1;
    });
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
    const navigate = useNavigate();

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    useEffect(() => {
        navigate(`/doctor-list?page=${currentPage}`);
    }, [currentPage, navigate]);

    useEffect(() => {
        fetchUsers();
    }, [currentPage, perPage, debouncedSearchTerm]);

    const fetchUsers = async () => {
        setIsLoading(true);
        await get(`all-user/list?per_page=${perPage}&current_page=${currentPage}&search=${debouncedSearchTerm}`)
            .then((response) => {
                setFilteredUsers(response.data?.users);
                setTotalRows(response.data?.total);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            }).finally(() => {
                setIsLoading(false);
            });
    };


    const handleAssignRole = (user) => {
        console.log("assign role clicked");
        console.log("user data", user);
        navigate(`/user-detail/${user._id}`, { state: { user, fromPage: currentPage } });
    };

    const columns = [
        {
            name: '#',
            selector: (row, index) => (currentPage - 1) * perPage + index + 1,
            sortable: true,
            width: '60px',
        },
        {
            name: 'User Name',
            selector: row => row?.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row?.email,
            sortable: true,
        },
        {
            name: 'Phone',
            selector: row => row?.phone,
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row?.type,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row?.status,
            sortable: true,
        },
        {
            name: 'Actions',
            selector: row => (
                <div className="flex gap-3">
                    <button
                        onClick={() => {
                            if (row.type === "doctor") {
                                navigate("/doctor-create-page", { state: { user: row } });
                            } else if (row.type === "staff" || row.type === "assistant") {
                                navigate("/create-staff", { state: { user: row } });
                            } else {
                                console.warn("Unknown user type:", row.type);
                            }
                        }}
                        className="px-3 py-1 bg-secondary text-white rounded"
                    >
                        Edit
                    </button>
                    <button onClick={() => handleAssignRole(row)}
                            className="w-fit px-2 ml-2 py-1 bg-primary text-white rounded">
                        Assign Role
                    </button>
                </div>
            ),
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#50b6b5',
                color: 'white',
                fontSize: '1rem',
                fontWeight: 'bold',
            },
        },
        rows: {
            style: {
                fontSize: '0.9rem',
            },
            stripedStyle: {
                backgroundColor: '#f6f6f6', // Light ash for striped rows
            },
            highlightOnHoverStyle: {
                backgroundColor: '#e0e0e0', // Slightly darker shade on hover
            },
        },
    };

    return (
        <div className='flex flex-col justify-center w-full gap-5'>
            <div className='flex justify-between items-center'>
                <PageTitle icon={<BiSolidUser />} title="Doctor List" />
                <div className='flex gap-4'>
                    <div className="flex items-center border-2 rounded-md w-80">
                        <span className="flex items-center justify-center rounded-bl rounded-tl px-2 text-zinc-500 bg-teal-800 h-full">
                            <FaSearch className="text-white" />
                        </span>
                        <input
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search by user name"
                            className="text-sm px-2 py-2 text-black rounded-md w-full placeholder-gray-500 focus:outline-teal-800"
                        />
                    </div>
                    <button
                        onClick={() => {
                            setShowRoleModal(true);
                        }}
                        className="flex items-center justify-center gap-3 text-sm px-4 py-2 bg-primary text-white rounded-md">
                        <span className="">
                            <TiUserAddOutline className="w-5 h-5" />
                        </span>
                        Create New Doctor/Staff
                    </button>
                </div>
            </div>

            {isLoading ? (
                <div className="text-center text-gray-500"><Loader /></div>
            ):(
                <div>
                <DataTable
                    columns={columns}
                    data={filteredUsers}
                    customStyles={customStyles}
                    highlightOnHover
                    striped
                />
            </div>
            )}


            {/* Custom Pagination */}
            <CustomPagination
                currentPage={currentPage}
                totalRows={totalRows}
                perPage={perPage}
                setCurrentPage={setCurrentPage}
                setPerPage={setPerPage}
            />

            <AnimatePresence>
                {/*{showPopup && (*/}
                {/*    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center">*/}
                {/*        <motion.div initial={{ scale: 0, opacity: 0 }}*/}
                {/*                    animate={{ opacity: 1, scale: 1 }}*/}
                {/*                    exit={{ opacity: 0 }}*/}
                {/*                    className="bg-white p-5 rounded-md shadow-lg">*/}
                {/*            <CreateUserForm*/}
                {/*                user={selectedUser}*/}
                {/*                createUser={handleCreateUser}*/}
                {/*                updateUser={handleUpdateUser}*/}
                {/*                fetchUsers={fetchUsers}*/}
                {/*                onClose={() => setShowPopup(false)}*/}
                {/*            />*/}
                {/*        </motion.div>*/}
                {/*    </div>*/}
                {/*)}*/}

                {showRoleModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                        <motion.div initial={{ scale: 0, opacity: 0 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0 }}
                                    className="bg-white p-6 rounded-md w-80">
                            <h2 className="text-lg font-semibold mb-4">Select Role</h2>

                            <button
                                className="w-full mb-3 p-2 bg-green-600 text-white rounded-md"
                                onClick={() => navigate("/doctor-create-page")}
                            >
                                Doctor
                            </button>

                            <button
                                className="w-full mb-3 p-2 bg-purple-600 text-white rounded-md"
                                onClick={() => navigate("/create-staff", { state: { role: "staff" } })}
                            >
                                Staff
                            </button>

                            <button
                                className="w-full p-2 bg-indigo-600 text-white rounded-md"
                                onClick={() => navigate("/create-staff", { state: { role: "assistant" } })}
                            >
                                Assistant
                            </button>

                            <button
                                onClick={() => setShowRoleModal(false)}
                                className="mt-4 text-gray-600 underline w-full"
                            >
                                Cancel
                            </button>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default DoctorList;
